import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-cotizacion-coberturas',
  templateUrl: './cotizacion-coberturas.component.html',
  styles: []
})
export class CotizacionCoberturasComponent implements OnInit {
  @Input()
  company:any;

  @Input()
  carId:any;

  @Input()
  coverages:any;

  quotes:any=null;
  loading:boolean=true;
  error:boolean=false;

  constructor(
    private api: ApiService
  ) { 

  }



  ngOnInit() {
    
    this.api.getQuotes(this.company.nombre, this.carId).subscribe(x => {
      this.loading = false;

      if(x.success){
        this.error = false;
        this.getCoverage(x.data);
      }else{
        this.error = true;
      }
    },err=>{
      this.loading = false;
      this.error = true;
    });

  }


  getCoverage(data:any){
    let costo;
    
    this.quotes = [];
    
    this.coverages.forEach(c => {
      if(data.prices[c.id] != undefined){
        costo = parseInt(data.prices[c.id].premio[data.cc.no]);

        if(data.cuotas){
          costo = costo / parseInt(data.cuotas);
        }

        this.quotes.push({
          nombre: c.nombre,
          costo: parseInt(costo)
        });
      }
    });

    console.log(this.quotes);
  }


}
